import { Col, Row } from "react-bootstrap";
import Breadcrumb from "shared/components/breadcrumbs/Breadcrumb";
import React from "react";
import ContadorBadge from "shared/components/badges/ContadorBadge";

interface HeaderPanelProps {
  title: string;
  botoes?: React.ReactNode[];
  contador?: number;
  nomeCondominio?: string;
  ocultarCondominio?: boolean;
  abaAtual?: string;
}

const HeaderPanel: React.FC<HeaderPanelProps> = (props) => {
  const tituloHeaderPanel = () => {
    return (
      <Col xs={6}>
        <h2 className="crud-panel-title contador d-flex gap-1">
          {props.title}
          {props.contador && <ContadorBadge contador={props.contador} />}
        </h2>
      </Col>
    );
  };

  const botoesHeaderPanel = () => {
    return (
      <Col xs={6}>
        <div className="title-action">
          {props.botoes?.map((botao) => {
            return botao;
          })}
        </div>
      </Col>
    );
  };

  return (
    <div className="pb-3">
      <Row className="wrapper-crud white-bg page-heading">
        {tituloHeaderPanel()}
        {botoesHeaderPanel()}
      </Row>
      <Row className="wrapper-crud border-bottom white-bg page-heading">
        <Breadcrumb
          nomeCondominio={props.nomeCondominio}
          ocultarCondominio={props.ocultarCondominio}
          abaAtual={props.abaAtual}
        />
      </Row>
    </div>
  );
};
export default HeaderPanel;
